import { mount } from "@vue/test-utils";
import DocumentationDetail from "@/components/core/modals/DocumentationDetail";

describe("DocumentationDetail component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(DocumentationDetail);
  });

  it("Renders del component DocumentationDetail", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
